import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import APIClient from './APIClient';
import Alert from './Alert';

import './Form.css';

class LoginForm extends React.Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    setLoggedIn: PropTypes.func.isRequired,
  };

  emailField = React.createRef();
  passwordField = React.createRef();

  state = {
    error: null,
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const email = this.emailField.current.value;
    const password = this.passwordField.current.value;

    this.setState({ error: null });

    APIClient.shared.login(email, password)
      .then(token => APIClient.shared.setToken(token))
      .then(() => this.props.setLoggedIn(true))
      .then(() => this.props.history.push('/'))
      .catch(error => this.setState({ error }));
  };

  render() {
    return (
      <div className="LoginForm">
        {this.state.error && <Alert title="Error" message={this.state.error.message} />}
        {!this.state.registered &&
          <form className="Form" onSubmit={this.handleSubmit}>
            <div className="Form__group">
              <label htmlFor="email">Email address</label>
              <input id="email" type="email" ref={this.emailField} />
            </div>

            <div className="Form__group">
              <label htmlFor="password">Password</label>
              <input id="password" type="password" ref={this.passwordField} />
            </div>

            <button type="submit">Log In</button>
            <Link className="Form__submit--helper" to="/forgotten">Forgotten password?</Link>
          </form>
        }
        {this.state.registered &&
        <Alert title="Confirm email address" message="Check your email for a confirmation link." />
        }
      </div>
    );
  }
}

export default LoginForm;



// WEBPACK FOOTER //
// ./src/LoginForm.js